module.exports = __webpack_public_path__ + "066180da03a3d34fb2b4eef9b35a5d89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_2_2023_chart.png
// module id = 1739
// module chunks = 0